module.exports = __webpack_public_path__ + "img/4de2a530bc56f371a79964e6a26db701.png";